import React from 'react';

interface ModernCardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
  shadow?: 'sm' | 'md' | 'lg' | 'xl';
  border?: boolean;
  gradient?: boolean;
}

const ModernCard: React.FC<ModernCardProps> = ({ 
  children, 
  className = '', 
  padding = 'md',
  shadow = 'md',
  border = true,
  gradient = false
}) => {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-5',
    lg: 'p-6'
  };

  const shadowClasses = {
    sm: 'shadow-sm',
    md: 'shadow-lg',
    lg: 'shadow-xl',
    xl: 'shadow-2xl'
  };

  const baseClasses = `
    rounded-2xl bg-white
    ${paddingClasses[padding]}
    ${shadowClasses[shadow]}
    ${border ? 'border border-gray-100' : ''}
    ${gradient ? 'bg-gradient-to-br from-white to-gray-50' : ''}
    transition-all duration-200 ease-in-out
    hover:shadow-lg hover:border-gray-200
    relative
  `;

  return (
    <div className={`${baseClasses} ${className}`}>
      {children}
    </div>
  );
};

export default ModernCard;


